<app-progressbar
  [totaal]="data.totaal"
  [actief]="data.actief"
  *ngIf="!data.hidden"
></app-progressbar>
